import { useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SelectWithLabelAsyncFilter from '../../../../common/SelectWithLabelAsyncFilter'
import Button from '../../../../common/Button'
import { filterActions } from '../../../../../store/filter'
import { workqueueActions } from '../../../../../store/workqueue'
import { attorneyActions } from '../../../../../store/attorneys'
import { removeStorageItem } from '../../../../../lib/script'
import { setFiltersInLocalStorage } from '../../../../../lib/filters'
import classes from './InvalidFaxWorkQ.module.css'

function savedLawFirmOption(lawFirm) {
    const entry = Array.isArray(lawFirm) ? lawFirm[0] : null
    if (!entry) {
        return null
    }
    const id = entry.value ?? entry.id ?? entry.item?.value ?? entry.item?.id
    if (id == null || id === '') {
        return null
    }
    return {
        label: entry.label || entry.item?.label || id,
        value: id,
    }
}

export default function InvalidFaxWorkQFilters({ workQ }) {
    const dispatch = useDispatch()
    const skipClearRefresh = useRef(false)
    const lawFirm = useSelector(state => state.filter.filters?.law_firm)
    const selectedLawFirm = useMemo(() => savedLawFirmOption(lawFirm), [lawFirm])

    function applyLawFirm(selection) {
        const next = selection ? { law_firm: selection } : {}
        dispatch(filterActions.setFiltersMultiple(next))
        dispatch(workqueueActions.setRefreshApi())
        if (selection) {
            setFiltersInLocalStorage(next, workQ?.slug)
        } else {
            removeStorageItem(workQ?.slug)
        }
    }

    function selectLawFirm(value) {
        const option = value?.option || value?.data?.value
        const id = option?.id ?? option?.value
        if (id == null || id === '') {
            return
        }
        applyLawFirm([{
            value: id,
            label: option.label,
            item: option,
            async: true,
        }])
    }

    function clearAllFiltersHandler() {
        skipClearRefresh.current = true
        dispatch(attorneyActions.setClearAsyncResults(true))
        applyLawFirm(null)
        setTimeout(() => {
            skipClearRefresh.current = false
        }, 0)
    }

    function clearFromSelect() {
        if (skipClearRefresh.current) {
            skipClearRefresh.current = false
            return
        }
        applyLawFirm(null)
    }

    return <>
        <div className={classes.law_firm_filter}>
            <SelectWithLabelAsyncFilter
                label="Law Firm"
                path="law-firms"
                action={selectLawFirm}
                onClear={clearFromSelect}
                identifier={{ type: 'law_firm' }}
                minWidth={280}
                icon="ti ti-building-skyscraper"
                isClearable
                selected={selectedLawFirm}
            />
        </div>
        <Button click={clearAllFiltersHandler} btnStyle="btn_white">Clear All Filters</Button>
    </>
}
